import { useEffect } from "react";

/**
 * Custom hook to prevent body scrolling when modal is open
 * @param isOpen - Whether the modal is open
 */
export const useModalBodyScroll = (isOpen: boolean): void => {
	useEffect(() => {
		if (isOpen) {
			// Prevent body scroll when modal is open
			document.body.style.overflow = "hidden";
		} else {
			// Restore body scroll when modal is closed
			document.body.style.overflow = "unset";
		}

		// Cleanup function to restore scroll when component unmounts
		return () => {
			document.body.style.overflow = "unset";
		};
	}, [isOpen]);
};
